import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import pipelineKeys from '@/api/queries/pipelines/keyFactory';
import { graphql } from '@/gql';
import { DeletePipelineMutation } from '@/gql/graphql';

const DELETE_PIPELINE_MUTATION = graphql(`
  mutation DeletePipeline($id: ID!) {
    deletePipeline(id: $id)
  }
`);

type DeletePipelineInput = {
  pipelineId: string;
};

const useDeletePipeline = (
  options?: UseMutationOptions<
    DeletePipelineMutation,
    unknown,
    DeletePipelineInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: (input) => {
      return gqlClient.request(DELETE_PIPELINE_MUTATION, {
        id: input.pipelineId,
      });
    },
    onSuccess: (...args) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountPipelines(),
      });
      void queryClient.invalidateQueries({
        queryKey: pipelineKeys.pipeline(args[1].pipelineId),
      });
      options?.onSuccess?.(...args);
    },
  });
};

export default useDeletePipeline;
